var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{key:`topic-${_vm.topic.id}-${_vm.myTopics}`,class:_vm.onHome ? 'topic onHome' : 'topic',style:(`z-index: 11; background-color: ${_vm.topic.color || '#edeae9'}; background-repeat: repeat-x; `),on:{"click":_vm.onClick}},[_c('h3',[_c('span',[_vm._v(_vm._s(_vm.topic.name))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }